const ErrorThrow = ({ message = "Unknown error" }) => {
  throw new Error(message)
}

export default ErrorThrow
